import { VwUser } from './Auth';

export const defaultUser = (): VwUser => {
	return {
		userInfo: null,
		data: null,
	};
};
